import React from "react";
import { connect } from "react-redux";
import ConnectionTypeRadio from "./ConnectionTypeRadio";
import ApiConnectionFieldset from "./ApiConnectionFieldset";
import { debug } from "../../utils";
import SshConnectionFieldset from "./SshConnectionFieldset";
import AnsibleConnectionFieldset from "./WinRmConnectionFieldset";
import PowerCLIConnectionFieldset from "./PowerCLIConnectionFieldset";
import MSConnectionFieldset from "./MSConnectionFieldset";

export const ConnectionTypes = {
    API: 'API',
    SSH: 'SSH',
    WINRM: 'WINRM',
    //LOG_FILE: 'LOG_FILE',
    PowerCLI: 'PowerCLI',
    M365: 'M365'
}

export function ConnectionTypeFieldset({ connectionType, disabled }) {
    switch (connectionType) {
        case ConnectionTypes.API:
            return <ApiConnectionFieldset disabled={disabled} />
        case ConnectionTypes.SSH:
            return <SshConnectionFieldset disabled={disabled} />
        case ConnectionTypes.WINRM:
            return <AnsibleConnectionFieldset disabled={disabled} />
        case ConnectionTypes.PowerCLI:
            return <PowerCLIConnectionFieldset disabled={disabled} />
        case ConnectionTypes.M365:
            return <MSConnectionFieldset disabled={disabled} />
            
        default:
            return <ApiConnectionFieldset disabled={disabled} />
    }
}

function ConnectionTypeSection({ connectionType, disabled, deviceType }) {
    return (
        <>
            <ConnectionTypeRadio disabled={disabled} selectedDeviceType={deviceType} />
            <ConnectionTypeFieldset connectionType={connectionType} disabled={disabled} />
        </>
    )
}

function mapStateToProps(state) {
    debug("ConnectionTypeSection mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        connectionType: addDeviceModal.connectionType
    };
}


export default connect(mapStateToProps)(ConnectionTypeSection);
